<template>
  <view class="transfer-info" wx:class="{{noIcon && 'noicon'}}">
    <!-- 组件名称 -->
    <view class="transfer-info-left">
      <image
        wx:if="{{!noIcon}}"
        class="transfer-info-left-icon"
        src="https://ut-static.udache.com/webx/sfc/6bN5XS8kMoyrAngJ01pVE.png"
      />
      <view class="transfer-info-left-title" wx:class="{{noIcon && 'noicon'}}">{{
        transferTitle
      }}</view>
      <view wx:if="{{stopTime}}" class="transfer-info-left-time">停留{{ stopTime }}</view>
    </view>
    <view wx:if="{{transferDiff && navTime}}" class="transfer-info-right">
      <view class="transfer-info-right-consuming" wx:class="{{noIcon && 'noicon'}}"
        >打车预计{{ navTime }}分钟</view
      >
      <view wx:if="{{isPassenger}}" class="transfer-info-right-navigation" bindtap="navigate">
        <image class="transfer-info-right-navigation-icon" src="{{navigateIcon}}" />
        <text class="navigation-text" wx:class="{{noIcon && 'noicon'}}">导航</text>
      </view>
    </view>
  </view>
</template>

<script>
    import { createComponent } from '@didi/es-mpx-creator'
    import { goTo, is, bridge, weixinReady, alimpReady, build } from '@didi/webx-js'
    import { requestNavTime } from '@/api/common'

    createComponent({
      props: {
        startStation: {
          type: String,
          value: ''
        },
        toStation: {
          type: String,
          value: ''
        },
        stopTime: {
          type: String,
          value: ''
        },
        noIcon: {
          type: Boolean,
          value: false
        }
      },
      mounted() {
        this.transferDiff && this.getNavTime()
      },
      data: {
        navTime: 0,
        navStart: {},
        navEnd: {}
      },
      computed: {
        transferDiff() {
          return this.startStation !== this.toStation && this.toStation !== ''
        },
        transferTitle() {
          return this.transferDiff ? '异站换乘' : '同站换乘'
        },
        navigateIcon() {
          return this.noIcon
            ? 'https://ut-static.udache.com/webx/sfc/wN_I567wBuBpkxo_kJ0K0.png'
            : 'https://ut-static.udache.com/webx/sfc/5G84n-iqojIEQlQNR3rMi.png'
        },
        isPassenger() {
          return is('passenger')
        }
      },

      methods: {
        navigate() {
          if (is('passenger')) {
            bridge.openPage({
              target: 'native',
              url: build('onetravel://router/page/driving', {
                from_page: 'carmate',
                target_page: 'route_select',
                navi_end_poi_srctag: 'srctag',
                target_page_flag: 3,
                ...this.navStart,
                ...this.navEnd
              })
            })
          } else if ('miniprogram') {
            return
          }
        },
        getNavTime() {
          const params = {
            from_station_name: this.startStation,
            to_station_name: this.toStation,
            order_id: this.orderId
          }
          requestNavTime(params).then((res) => {
            const { data, message, code, success } = res || {}
            const { start_point, dest_point, time } = data || {}
            this.navStart = {
              navi_start_lng: start_point?.lng ?? '',
              navi_start_lat: start_point?.lat ?? '',
              navi_start_name: start_point?.station_name ?? '',
              navi_start_address: start_point?.address ?? '',
              navi_start_poi_id: start_point?.poi_id ?? ''
            }
            this.navEnd = {
              navi_end_lng: dest_point?.lng ?? '',
              navi_end_lat: dest_point?.lat ?? '',
              navi_end_name: dest_point?.station_name ?? '',
              navi_end_address: dest_point?.address ?? '',
              navi_end_poi_id: dest_point?.poi_id ?? ''
            }
            this.navTime = time
          })
        }
      }
    })
</script>

<style scoped lang="stylus">
  .transfer-info
    display flex
    justify-content space-between
    align-items center
    padding 7px 20px
    background-color #fff
    &.noicon
      padding 12px 0
    &-left
      display flex
      align-items center
      &-icon
        height 11px
        width 11px
        margin-right 3px
      &-title
        font-family PingFangSC-Medium
        font-size 12px
        font-weight 500
        line-height 18px
        color #222
        margin-right 8px
        &.noicon
          font-size 18px
      &-time
        font-size 12px
        font-weight 400
        line-height 14px
        color #666
    &-right
      display flex
      align-items center
      font-size 12px
      font-weight 400
      line-height 14px
      color #338FFF
      &-navigation
        display flex
        align-items center
        position relative
        margin-left 16.5px
        &::after
          content ''
          position absolute
          height 24px
          width 1px
          left -8px
          top 50%
          transform translateY(-50%) scale(0.5)
          background rgba(102, 102, 102, 0.502)
        &-icon
          height 12px
          width 12px
          margin-right 2px
        .navigation-text
          &.noicon
            color #333
      &-consuming
        position relative
        &.noicon
          color #666
</style>

<script name="json">
    module.exports = {
      component: true,
      usingComponents: {}
    }
</script>